import { makeService } from './api';

const service = makeService('menus');

export default service;